import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

export function PageHeader({ title, gold, sub, action }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 28, gap: 16, flexWrap: "wrap" }} className="fade-in page-head-row">
      <div>
        <h1 className="page-title" data-testid="page-title">
          {title} {gold && <span className="gold">{gold}</span>}
        </h1>
        {sub && <p className="page-sub">{sub}</p>}
      </div>
      {action && <div className="page-header-actions" style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>{action}</div>}
    </div>
  );
}

export function StatCard({ icon: Icon, label, value, foot, footColor, testid }) {
  return (
    <div className="card stat-card hoverable" data-testid={testid}>
      <div className="stat-ico"><Icon size={21} /></div>
      <div className="stat-label">{label}</div>
      <div className="stat-value">{value}</div>
      {foot && <div className="stat-foot" style={footColor ? { color: footColor } : {}}>{foot}</div>}
    </div>
  );
}

export function StatusBadge({ status }) {
  const { t } = useTranslation();
  const map = {
    "Brouillon": "badge-muted",
    "Soumise": "badge-gold",
    "Approuvée contremaître": "badge-gold",
    "En révision paie": "badge-gold",
    "Approuvée": "badge-green",
    "Refusée": "badge-red",
    "Exportée": "badge-green",
    "Payée": "badge-green",
    "Verrouillée": "badge-muted",
    "Valide": "badge-green",
    "Anomalie": "badge-red",
    "Critique": "badge-red",
    "Moyen": "badge-gold",
    "Faible": "badge-muted",
    "Ouverte": "badge-red",
    "Actif": "badge-green",
    "En pause": "badge-muted",
    "Réussi": "badge-green",
  };
  const label = status ? t(`status.${status}`, { defaultValue: status }) : status;
  return <span className={`badge ${map[status] || "badge-muted"}`}>{label}</span>;
}

export function Loader({ label = "Chargement…" }) {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 12, padding: 80, color: "var(--muted)" }}>
      <Loader2 className="spin" size={22} color="var(--gold)" /> {label}
    </div>
  );
}

export function Avatar({ name, color }) {
  const initials = name.split(" ").map((w) => w[0]).slice(0, 2).join("");
  return (
    <div style={{ width: 36, height: 36, borderRadius: 10, display: "flex", alignItems: "center",
      justifyContent: "center", fontWeight: 700, fontSize: 13, color: "#050505",
      background: color || "var(--gold)" }}>{initials}</div>
  );
}
